import { assert_false, assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__t2i_adapter } from '../../../_invocations/sd/guidance/INVOCATION_SD__t2i_adapter';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__color(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_not_null(graph);
  assert_false(graph.is_stub());

  /*
   *
   */
  let node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  /*
   * CONTROL NET CANNY
   */

  let node__t2i_color = INVOCATION_SD__t2i_adapter.create_node_for(graph, ENUM.T2I_ADAPTER__COLOR);

  if (!graph.nodes__are_connected_directly(node__t2i_color.meta.node_id, node__denoise.meta.node_id)) {
    graph.edge__try_add_for_fields(node__t2i_color.t2i_adapter, node__denoise.t2i_adapter);
  }

  /*
   * UI
   */

  let fields__visible: FIELD__base[] = [node__t2i_color.t2i_adapter.image, node__t2i_color.t2i_adapter.weight];
  let field_column_id = node__t2i_color.t2i_adapter.weight.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.APPLY_COLOR,
    group: '2. Control',
    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    //
    field_id_info__has_affect_on_generation: node__t2i_color.t2i_adapter.image.meta.field_id,
  });
}
